<template>
  <div class="bbsCon">
    <template v-if="listData.length > 0">
      <div v-for="(item,index) in listData" :key="index" class="broadcastbbsList">
        <div class="broadcastbbsListop">
          <div class="opopic">
            <img
              :src="item.broadcast_logo || errorImage " style="width: 100%;height: 100%;object-fit: contain;"/>
          </div>
          <div class="opooinfo">
            <div class="opooinfoMain">
              <div class="opooinfoName">{{item.broadcast_name}}</div>
              <div class="opooinfoTime">{{language.time}}：{{item.periodTime}}</div>
            </div>
            <div class="opooinfosm">
              <ul>
                <li><span style="margin-right:16px;display: inline-block;">{{item.exh_name}}</span></li>
                <li><span style="margin-right:16px;display: inline-block;">{{item.exh_begtime}} {{language.to}} {{item.exh_endtime}}</span>
                </li>
              </ul>
            </div>
            <div class="opooinfosm">
              <ul>
                <li><span style="margin-right:16px;display: inline-block;width:54px">{{language.compere}}:</span>{{item.truename}}
                </li>
              </ul>
            </div>
            <div class="opooinfobt">
              <ul>
                <li>
                  <!--<span style="margin-right:56px;display: inline-block;width:54px">{{language.guest}}<span
                    style="margin-left: 14px">{{language.client}}</span>:</span>-->
                  <span style="margin-right:16px;display: inline-block;width:54px">{{language.bbsVisitor}}:</span>
                  <span class="btname">{{item.user_post}}</span>
                </li>
              </ul>
            </div>

          </div>
        </div>
        <div class="broadcastbbsListxt">{{item.broadcast_introduce}}</div>
        <div class="broadcastbbsLisBtn">
          <el-button type="primary" @click="showImg(item)" v-if="lan == 'ch'" style="background: #003f8f">手机海报分享</el-button>
          
          <el-tooltip class="item" effect="dark" :content="language.appointmentltsotes" placement="top">
            <el-button type="primary" @click="handleSee(item)" style="background: #003f8f">{{language.appointments}}
            </el-button>
          </el-tooltip>
          <el-button type="primary" @click="editData(item.broadcast_id)" style="background: #003f8f" v-if="userInfo.user_admin_state == '1'">
            {{language.editExh}}
          </el-button>
          
          <el-tooltip class="item" effect="dark" :content="language.enterExhltnotes" placement="top">
            <el-button type="primary" @click="joinData(item.broadcast_id)" style="background: #ff9e00">{{language.enterExh}}</el-button>
          </el-tooltip>
        </div>
      </div>
    </template>
    <template v-else>
      <error-card :language="language"/>
    </template>
    <!--查看预约弹窗-->
    <drag-dialog
      :show.sync="dialogShow"
      :title="title"
      :columns="columns"
      :language="language"
      :fn="stateEnum.SEEAPPOINTMENT"
      :init-cont="initCount"
      width="520px"
    />
  </div>
</template>
<script>
  import errorImage from "../../../../assets/error_forum.png"
  import errorCard from "../errorCard/index"
  import {mapGetters} from "vuex";
  import dragDialog from "../../../../components/DragDialog/index";
  import {stateEnum} from "../../attendancerecord/enum";
  import Cookie from "../../../../common/cookie";
  export default {
    components: {
      errorCard,
      dragDialog
    },
    computed: {
      ...mapGetters(["userInfo"])
    },
    props: {
      listData: {
        type: Array,
        default: () => {
          return []
        }
      },
      language: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data() {
      return {
        lan: Cookie.get("lang"),
        errorImage,
        stateEnum,
        dialogShow: false,
        title: "",
        initCount: null,
        columns: [
          {
            title: this.language.name,
            key: "true_name",
            width: "105"
          },
          {
            title: this.language.hintContact,
            key: "tel",
            width: "130"
          },
          {
            title: this.language.companyName,
            key: "company",
            width: "244"
          }
        ]
      }
    },
    methods: {
      editData(id) {
        this.$emit('editData', id)
      },
      joinData(id) {
        this.$emit("joinData", id)
      },
      showImg(item) {
        this.$emit("showImg", item)
      },
      //查看预约
      handleSee(val) {
        this.title = this.language.watch + "-" + val.broadcast_name
        this.initCount = val;
        this.dialogShow = true;
      }
    }
  }
</script>
<style>
  .broadcastbbs .bbsCon {
    min-height: 500px
  }

  .broadcastbbs .broadcastbbsList {
    width: 100%;
    background: #fff;
    margin-top: 10px;
    box-shadow: 0px 5px 6px rgba(205, 205, 205, 0.7);
    padding: 22px;
    padding-left: 38px;
    box-sizing: border-box;
  }

  .broadcastbbs .broadcastbbsList .broadcastbbsListop {
    /* display: flex; */
  }

  .broadcastbbs .broadcastbbsList .opopic {
    width: 386px;
    height: 100px;
    margin: 0 auto;
    margin-bottom: 20px
  }

  .broadcastbbs .broadcastbbsList .opopic img {
    width: 100%;
    height: 100%;
  }

  .broadcastbbs .broadcastbbsList .opooinfo {
    margin-left: 21px;
  }

  .broadcastbbs .broadcastbbsList .opooinfo .opooinfoMain {
    display: flex;
    justify-content: space-between
  }

  .broadcastbbs .broadcastbbsList .opooinfo .opooinfoMain .opooinfoTime {
    font-size: 16px;
    color: #424242;
    line-height: 37px;
  }

  .broadcastbbs .broadcastbbsList .opooinfo .opooinfoName {
    font-size: 28px;
    color: #0f408a;
    font-weight: bold
  }

  .broadcastbbs .broadcastbbsList .opooinfo .opooinfosm {
    margin: 27px 0 17px 0;
    font-size: 14px;
    color: #424242;
  }

  .broadcastbbs .broadcastbbsList .opooinfo .opooinfobt {
    font-size: 14px;
    color: #424242;
  }

  .broadcastbbs .broadcastbbsList .opooinfo .opooinfobt .btname {
    margin-right: 40px
  }

  .broadcastbbs .broadcastbbsList .opooinfo .opooinfosm ul,
  .broadcastbbs .broadcastbbsList .opooinfo .opooinfobt ul {
    display: flex;
    align-items: center;
  }

  .broadcastbbs .broadcastbbsList .opooinfo .opooinfosm ul li {
    margin-right: 40px;
  }

  .broadcastbbs .broadcastbbsList .opooinfo .opooinfobt ul li {
    margin-right: 20px;
  }

  .broadcastbbs .broadcastbbsList .broadcastbbsListxt {
    font-size: 14px;
    color: #a1a1a1;
    margin: 20px 0;
    margin-left: 21px
  }

  .broadcastbbs .broadcastbbsList .broadcastbbsLisBtn {
    text-align: right;
  }

  .broadcastbbs .broadcastbbsList .broadcastbbsLisBtn button {
    text-align: right;
    width: 100px;
    height: 40px;
    border-radius: 10px;
    border: none;
    padding: 0;
    font-size: 14px;
    text-align: center;
  }

  .broadcastbbs .broadcastbbsList .broadcastbbsLisBtn button:nth-of-type(2) {
    background: #003f8f;
  }

  .broadcastbbs .broadcastbbsList .broadcastbbsLisBtn button:nth-of-type(3) {
    background: #ff9e00;
  }
</style>